var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-form"},[_c('DxCheckBox',{attrs:{"value":!!_vm.formData.generate_document,"text":_vm.$t('stock_management.storage_losses.generate_document')},on:{"value-changed":function($event){return _vm.$emit('input', { generate_document: !!$event.value })}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }